import React, { useEffect, useState } from 'react';
import {
  useSelector,
} from 'react-redux';
import { useParams } from 'react-router-dom';
import { Toolbar, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ContentBox from '../components/layout/ContentBox';
import ZerpaTable, { ColumnObject } from '../components/layout/table/ZerpaTable';
import { useAppDispatch } from '../hooks/reduxHooks';

import {
  fetchTrialAndSurvey,
  fetchFeedbacks,
} from '../redux/actions';
import downloadAsExcel from '../components/utilities/ExcelExport';
import { RootState, FeedbackViewType, DigitalSurvey } from '../redux/types';
import { getDigitalSurveyByTrialId } from '../loopback/apiClient/DRTApi';

const columns: ColumnObject[] = [
  {
    keyName: 'comment',
    text: 'Comment',
    sortable: true,
  },
  {
    keyName: 'rating',
    text: 'Rating',
    type: 'rating',
    sortable: true,
  },
];

type MatchParams = {
  trialId: string;
}

const FeedbackView: React.FC = () => {
  const params = useParams<MatchParams>();
  const dispatch = useAppDispatch();
  const { trialId } = params;
  const stateSurveyId = useSelector((state: RootState) => state.trial?.trial?.survey?.id);
  const trial = useSelector((state: RootState) => state.trial?.trial);
  const feedback = useSelector((state: RootState) => state.feedback.feedbackList);
  const [surveyV2, setSurveyV2] = useState<DigitalSurvey>();

  useEffect(() => {
    dispatch(fetchTrialAndSurvey(Number(trialId)));
    getDigitalSurveyByTrialId(Number(trialId))
      .then((digitalSurveys) => digitalSurveys.filter((ds) => (!ds.exercise)))
      .then((selectedSurvey) => {
        if (selectedSurvey.length > 0) {
          setSurveyV2(selectedSurvey[0]);
        }
      });
  }, [dispatch, trialId]);

  useEffect(() => {
    if (trial?.version && trial.version > 1 && surveyV2) {
      dispatch(fetchFeedbacks(undefined, surveyV2?.id));
    } else if (stateSurveyId) {
      dispatch(fetchFeedbacks(Number(stateSurveyId)));
    }
  }, [dispatch, stateSurveyId, surveyV2, trial?.version]);

  const onExcelExport = () => {
    const excelMatrix = [
      ['Comment', 'rating'],
    ];
    feedback?.forEach((fb) => {
      excelMatrix.push([fb.comment, fb.rating.toString()]);
    });
    if (feedback) {
      downloadAsExcel(excelMatrix, `feedback-trial-${trialId}`);
    }
  };

  return (
    <ContentBox elevation={0} title="Feedback">
      <Toolbar disableGutters>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>{trial?.name}</Typography>
        <Button variant="outlined" onClick={onExcelExport}><FormattedMessage id="feedback.export" /></Button>
      </Toolbar>
      <ZerpaTable<FeedbackViewType>
        dense
        keyIdentifier="id"
        tableRows={feedback}
        columns={columns}
      />
    </ContentBox>
  );
};

export default FeedbackView;
